import { render, staticRenderFns } from "./dashboard-sidebar.vue?vue&type=template&id=2d623a22&scoped=true&"
import script from "./dashboard-sidebar.vue?vue&type=script&lang=ts&"
export * from "./dashboard-sidebar.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-sidebar.vue?vue&type=style&index=0&id=2d623a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d623a22",
  null
  
)

export default component.exports